<template>
  <div class="def-and-guide-list">
    <div class="header">
      <h2>Definitions and Guidelines</h2>
    </div>
    <div class="tabs">
      <div class="tab" v-for="tab in tabs"
           @click="e => activeTab = tab.value"
           :class="{active: activeTab === tab.value}"
      >{{ tab.label }}
      </div>
    </div>
    <div class="tab-viewer">
      <template v-if="activeTab === 0">
        <DefListTile v-for="def in mapStore.state.map.definitionsAndGuidelines.definitions"
                     :def="def"
        />
      </template>
      <template v-if="activeTab === 1">
        <GuideListTile v-for="guide in mapStore.state.map.definitionsAndGuidelines.guidelines"
                     :guide="guide"
        />
      </template>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, inject, PropType, ref} from "vue";
import DefListTile from "@/components/DefListTile.vue";
import GuideListTile from "@/components/GuideListTile.vue";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "DefAndGuideList",
  components: {DefListTile, GuideListTile},
  setup(props) {
    const tabs = [
      {label: "Definitions", value: 0},
      {label: "Guidelines", value: 1},
    ]
    const activeTab = ref(0);
    const mapStore = useMapStore()
    return {
      mapStore,
      tabs,
      activeTab,
    }

  }
})
</script>
<style lang="scss">
@import "src/assets/styles/vars";

.def-and-guide-list {
  width: 20vw;
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    padding: 4vh $default-padding;
    background-color: $primary;

    h2 {
      color: white;
      margin-bottom: 3.5vh;
    }

    h4 {
      margin: 2vh 0 1vh 0;
      font-size: 1.6vh;
      font-weight: bold;

      a, i {
        color: white;

        &:hover {
          color: $accent
        }
      }
    }
  }

  .tabs {
    display: flex;

    .tab {
      color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      background-color: $primary;
      height: 4vh;
      font-size: $list-tile-font-size;
      cursor: pointer;
      padding-bottom: 5px;

      &:hover {
        border-bottom: 5px solid $special;
        padding-bottom: 0;
        color: white;
      }

      &.active {
        padding-bottom: 0;
        border-bottom: 5px solid $special;
      }

    }
  }

  .tab-viewer {
    height: 0;
    flex-grow: 1;
    overflow: auto;
  }
}
</style>